import { render, staticRenderFns } from "./ExpenseDetailFooter.vue?vue&type=template&id=3c543b63&"
import script from "./ExpenseDetailFooter.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetailFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c543b63')) {
      api.createRecord('3c543b63', component.options)
    } else {
      api.reload('3c543b63', component.options)
    }
    module.hot.accept("./ExpenseDetailFooter.vue?vue&type=template&id=3c543b63&", function () {
      api.rerender('3c543b63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyExpenseMobile/ExpenseDetailFooter.vue"
export default component.exports